let apiBase = {
  treeCategory: '/api/p/gameFaqCategory/treeCategory',
  recommend: '/api/p/gameFaqCategory/recommend',
  categoryDetail: '/api/p/gameFaqCategory/detail',
  queryPage: '/api/p/gameFaq/queryPage',
  queryDetail: '/api/p/gameFaq/queryDetail',
  search: '/api/p/gameFaq/search',
  voteIsUseful: '/api/p/gameFaq/voteIsUseful',
}
let singleGameProblemServerObject = null

class GameProblemServer {
  constructor() {}

  treeCategory(params = {}) {
    return $http({
      method: 'get',
      url: apiBase.treeCategory,
      params: params,
    })
  }

  recommend(params = {}) {
    return $http({
      method: 'get',
      url: apiBase.recommend,
      params: params,
    })
  }

  categoryDetail(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.categoryDetail,
      data: params,
    })
  }

  queryPage(params = {}) {
    return $http({
      method: 'get',
      url: apiBase.queryPage,
      params: params,
    })
  }

  queryDetail(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryDetail,
      data: params,
    })
  }

  search(params = {}) {
    return $http({
      method: 'get',
      url: apiBase.search,
      params: params,
    })
  }

  voteIsUseful(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.voteIsUseful,
      data: params,
    })
  }
}

function singleGameProblemServer() {
  if (singleGameProblemServerObject === null) {
    singleGameProblemServerObject = new GameProblemServer()
  }
  return singleGameProblemServerObject
}

export default singleGameProblemServer()
